import prod from '@env/baseUrls/prod';
import staging from '@env/baseUrls/staging';
import dev from '@env/baseUrls/dev';
import useRunEnv from '@composable/useRunEnv';

const useBaseUrls = () => {
    const runEnv = useRunEnv();
    const baseUrls =
        runEnv === 'prod' ? prod : runEnv === 'staging' ? staging : dev;
    const repairedBaseUrls: { [key: string]: string } = {};
    Object.keys(baseUrls).forEach(key => {
        repairedBaseUrls[key] = ((baseUrls as any)[key] as string).replace(
            /\/+$/,
            ''
        );
    });
    return repairedBaseUrls as typeof baseUrls;
};

export default useBaseUrls;

export type BaseUrls = ReturnType<typeof useBaseUrls>;
